// extracted by mini-css-extract-plugin
module.exports = {"root":"VirtualMachinesTableActions_root__1Ds03","action":"VirtualMachinesTableActions_action__vXKk-","linkAction":"VirtualMachinesTableActions_linkAction__2Mv6Z"};